import React from "react";
import { useSelector } from "react-redux";

const useMigrateToNewUi = () => {
  const auth = useSelector((state) => state.auth);
  const prepareNewUiData = () => {
    const params = new URLSearchParams(window.location.search);
    let token = localStorage.getItem("token") || "";
    if (token.includes("||master")) {
      token = token.replace(/(\|\|master)+$/, "");
    }
    const data = {
      authToken: token,
      authUser: { email: auth.email },
      currentUser: { email: auth.email, userType: "hotel_user" },
      groupHotelDetails: [],
      groupId: localStorage.getItem("mainGroupId"),
      hotelDetail: {
        hotelName: auth.selectedHotel.hotelName,
        hotelCurrency: auth.selectedHotel.hotelCurrency,
      },
      hotelEmail: localStorage.getItem("HotelEmail"),
      hotelId: params.get("hotelId"),
    };
    if (localStorage.getItem("rootEmail")) {
      data["masterUser"] = {
        email: localStorage.getItem("rootEmail"),
      };
    }
    return data;
  };

  const directToNewUi = () => {
    // required: authToken, authUser, currentUser, groupHotelDetails, groupId, hotelDetail, hotelEmail, hotelId
    const data = prepareNewUiData();
    const url = "https://pms.stayflexi.com/property-dashboard/";
    const encodedData = JSON.stringify(data);
    const href = `${url}?data=${encodedData}`;
    window.location.href = href;
  };
  return { directToNewUi };
};

export default useMigrateToNewUi;
